import { render, staticRenderFns } from "./ProposalReviewUserDetail.vue?vue&type=template&id=2149edba"
import script from "./ProposalReviewUserDetail.vue?vue&type=script&lang=js"
export * from "./ProposalReviewUserDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports